module.exports = __webpack_public_path__ + "static/media/FENGYUN 2E.f04aa702.czml";